var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, ElementRef, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { HasSubscriptions } from '../../has-subscriptions';
import { debounceTime, filter } from 'rxjs/operators';
import { FormBuilder } from '@angular/forms';
import { SearchResult } from '../../search-bar/search-bar.component';
import { ListingsService } from '../../../services/listings.service';
import { Router } from '@angular/router';
var HomeEstimatorSearchBarComponent = /** @class */ (function (_super) {
    __extends(HomeEstimatorSearchBarComponent, _super);
    function HomeEstimatorSearchBarComponent(document, _formBuilder, _listingService, cdRef, _router) {
        var _this = _super.call(this) || this;
        _this.document = document;
        _this._formBuilder = _formBuilder;
        _this._listingService = _listingService;
        _this.cdRef = cdRef;
        _this._router = _router;
        _this.isSearching = false;
        _this.showAdditionalActionsButtons = false;
        _this.locationResults = [];
        _this.showSearchResults = false;
        _this.placeholder = '';
        _this.focus = false;
        _this.searchForm = _this._formBuilder.group({ searchInput: '' });
        return _this;
    }
    Object.defineProperty(HomeEstimatorSearchBarComponent.prototype, "searchInput", {
        get: function () {
            return this.searchForm.controls.searchInput.value;
        },
        set: function (value) {
            this.searchForm.controls.searchInput.setValue(value);
        },
        enumerable: true,
        configurable: true
    });
    HomeEstimatorSearchBarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addSub(this.searchForm.get('searchInput').valueChanges
            .pipe(debounceTime(200))
            .pipe(filter(function (searchInput) {
            if (!searchInput) {
                _this._resetResults();
                return false;
            }
            return true;
        }))
            .subscribe(function (s) { return _this._getQueryPredictionsSearch(s); }));
    };
    HomeEstimatorSearchBarComponent.prototype.onSearchInputClick = function () {
        this._getQueryPredictions();
        this.showSearchResults = true;
    };
    HomeEstimatorSearchBarComponent.prototype._getQueryPredictions = function () {
        if (!!this.searchInput) {
            this._getQueryPredictionsSearch(this.searchInput);
        }
        else
            this._resetResults();
    };
    HomeEstimatorSearchBarComponent.prototype._getQueryPredictionsSearch = function (searchInput) {
        var _this = this;
        if (this.offMarketSubscription) {
            this.offMarketSubscription.unsubscribe();
        }
        this.isSearching = true;
        this.offMarketSubscription = this._listingService.searchOffMarketListings(searchInput)
            .subscribe(function (s) {
            return _this._handleQueryPredictions(searchInput, s);
        });
    };
    HomeEstimatorSearchBarComponent.prototype._handleQueryPredictions = function (searchInput, listings) {
        if (listings !== null && listings.results !== null && listings.results.length >= 0) {
            var list = listings.results.map(function (e) { return new SearchResult(e.addressLine, e.detailUrl, 'location'); });
            this.locationResults = list;
        }
        this.isSearching = false;
        this.cdRef.detectChanges();
    };
    HomeEstimatorSearchBarComponent.prototype._resetResults = function () {
        this.locationResults = [];
    };
    HomeEstimatorSearchBarComponent.prototype.onLoseFocus = function () {
        var _this = this;
        setTimeout(function () {
            if (!_this.searchBarRef.nativeElement.contains(_this.document.activeElement))
                _this.showSearchResults = false;
        });
    };
    HomeEstimatorSearchBarComponent.prototype.onSelectResult = function ($event) {
        this._router.navigate([$event.data]);
        this.showSearchResults = false;
        this.focus = false;
    };
    HomeEstimatorSearchBarComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        if (this.offMarketSubscription) {
            this.offMarketSubscription.unsubscribe();
        }
    };
    return HomeEstimatorSearchBarComponent;
}(HasSubscriptions));
export { HomeEstimatorSearchBarComponent };
